// extracted by mini-css-extract-plugin
export default {"rectangle":"slider_rectangle__WrGgR","box":"slider_box__FQJ9U","arrow":"slider_arrow__MfPBZ","values":"slider_values__6Vqfg"};